import { $getRoot } from 'lexical';
import { BrandColorRef } from 'modules/BrandDefinition';
import { $getTextNodeStyleValueForProperty, $patchTextNodeStyle } from 'modules/Lexical/lexicalUtils';
import { FontPluginStyle, getStyleObjectForBrandColor } from 'modules/Lexical/Plugins/FontPlugin/style';

import * as Models from 'models';
import { colorExistsInBrandColors } from 'utils/brandStyles';

export const $matchFontColor = (
  colors: Models.BrandColorsList,
  brandColorRef: BrandColorRef,
): string | undefined => {
  let areSeveralColorsApplied = false;
  let commonColorName = '';

  $getRoot().getAllTextNodes().forEach((node, index) => {
    const currentColorName = $getTextNodeStyleValueForProperty(node, FontPluginStyle.BRAND_COLOR_NAME, '');

    if (currentColorName !== brandColorRef.name) {
      const styleExists = colorExistsInBrandColors(currentColorName, colors);

      if (!styleExists) {
        const style = getStyleObjectForBrandColor(colors, brandColorRef);
        $patchTextNodeStyle(node, style);
      }
    }

    // save first font color style for further detecting whether multiple font colors applied
    if (index === 0) {
      commonColorName = currentColorName;
    } else if (!areSeveralColorsApplied && currentColorName !== commonColorName) {
      areSeveralColorsApplied = true;
    }
  });

  return areSeveralColorsApplied ? undefined : commonColorName;
};
